import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'priceLevel'
})
export class PriceLevelPipe implements PipeTransform {

    transform(value: any, ...args: any[]): any {
        switch (value) {
            case 'Ret_incl_VAT':
                return 'Pharmacy Price with VAT';
            case 'Ret_excl_VAT':
                return 'Pharmacy Price without VAT';
            case 'WHS_excl_VAT':
                return 'Wholesale Price';
            case 'ExF_excl_VAT':
                return 'Ex-Factory List Price';
            default:
                return value;
        }
    }
}
